import {
  DropdownFilter,
  type DropdownFilterItemContent,
} from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import type { ReactNode } from 'react';
import { SearchBoxButton } from '../SearchBoxButton';

export interface RulesManagerFiltersProps<T extends string> {
  onSearchChange: (searchValue: string) => void;
  onFiltersChange: (selectedFilter: T) => void;
  searchValue: string;
  dropdownItems: DropdownFilterItemContent<T>[];
  selectedFilter: T;
  children?: ReactNode;
}

export function RulesManagerFilters<Filter extends string>({
  searchValue,
  onSearchChange,
  onFiltersChange,
  dropdownItems,
  selectedFilter,
  children,
}: RulesManagerFiltersProps<Filter>) {
  const [isSearchActive, setIsSearchActive] = useBoolean(false);

  return (
    <div className="flex items-center justify-between gap-2 pb-5">
      {!isSearchActive && (
        <>
          {children}
          <div className="w-full flex">
            <DropdownFilter<Filter>
              placeholder="Type"
              items={dropdownItems}
              onSelect={onFiltersChange}
              selected={selectedFilter}
              contentWidth={200}
            />
          </div>
        </>
      )}

      <SearchBoxButton
        value={searchValue}
        onChange={onSearchChange}
        onOpen={setIsSearchActive.setTrue}
        onClose={setIsSearchActive.setFalse}
      />
    </div>
  );
}
